import { FC } from 'react';

import { Box, css, styled } from '@mui/material';
import { components, MenuProps } from 'react-select';

import { LanguageOption } from './locale-picker.types';

export const LocalePickerMenu: FC<MenuProps<LanguageOption, false>> = ({ children, ...props }) => (
  <components.Menu {...props}>
    <StyledMenu mt={2}>{children}</StyledMenu>
  </components.Menu>
);

const StyledMenu = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  `
);
